import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedAppId: null,
  selectedAppIdName: null,
  appetiteData: null,
  totalApplications: null,
  selectedApplicationData: null,
  selectedApplicationIdData: null,
  currentPage: 1,
  uniqueValues: null,
  navList: [{ label: "Home", path: "/app/details" }],
  selectedPDFDataWithCoordinates: null,
  selectedPDFDataWithoutCoordinates: null,
};

const applicationSlice = createSlice({
  name: "application",
  initialState,
  reducers: {
    setAppId: (state, action) => {
      state.selectedAppId = action.payload;
    },
    setSelectedAppIdName: (state, action) => {
      state.selectedAppIdName = action.payload;
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setTotalApplications: (state, action) => {
      state.totalApplications = action.payload;
    },
    setAppetiteData: (state, action) => {
      state.appetiteData = action.payload;
    },
    selectedApplicationData: (state, action) => {
      state.selectedApplicationData = action.payload;
    },
    setSelectedApplicationIdData: (state, action) => {
      state.selectedApplicationIdData = action.payload;
    },
    setUniqueValues: (state, action) => {
      state.uniqueValues = action.payload;
    },
    addBreadcrumb: (state, action) => {
      const newBreadcrumb = action.payload;
      // Prevent duplicates
      //if (!state.items.some(item => item.path === newBreadcrumb.path)) {
      state.navList.push(newBreadcrumb);
      //}
    },
    resetBreadcrumbs: (state) => {
      state.navList = [{ label: "Home", path: "/app/details" }];
    },
    setPDFDataWithCoordinates: (state, action) => {
      state.selectedPDFDataWithCoordinates = action.payload;
    },
    setPDFDataWithoutCoordinates: (state, action) => {
      state.selectedPDFDataWithoutCoordinates = action.payload;
    },
  },
});

export const {
  setAppId,
  setSelectedAppIdName,
  setCurrentPage,
  setUniqueValues,
  setAppetiteData,
  setTotalApplications,
  setSelectedApplicationIdData,
  selectedApplicationData,
  addBreadcrumb,
  resetBreadcrumbs,
  setPDFDataWithCoordinates,
  setPDFDataWithoutCoordinates,
} = applicationSlice.actions;
export default applicationSlice.reducer;
